export default __webpack_public_path__ + "static/media/Automated Ridesharing.c9dee3cd.pdf";